class TextStats {
  constructor() {
    this._init();
  }

  _init() {
    const counters = document.querySelectorAll('.text-stats__item-number.counter');
    if (!counters.length) return;

    const options = {
      root: null,
      rootMargin: '0px',
      threshold: 0.5,
    };

    const observer = new IntersectionObserver((entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const target = entry.target as HTMLElement;
          this._animateCounter(target);
          observer.unobserve(target);
        }
      });
    }, options);

    counters.forEach(counter => observer.observe(counter));
  }

  _animateCounter(element: HTMLElement) {
    const target = parseInt(element.getAttribute('data-target') || '0', 10);
    const duration = 2000; // 2 seconds
    const stepTime = Math.abs(Math.floor(duration / target));
    let current = 0;

    if (target === 0) return;

    const timer = setInterval(() => {
      current += Math.ceil(target / 100); // Increment by 1% of target for smoother feel if large
      if (current >= target) {
        element.textContent = target.toString();
        clearInterval(timer);
      } else {
        element.textContent = current.toString();
      }
    }, 20); // Faster refresh for smoother animation
  }
}

export const textStats = new TextStats();
